export default __webpack_public_path__ + "audio1350e4.png";